import { KnownTypes } from '../types/enums'

export class Types {
    public static convertType<NewType>(obj: unknown): NewType {
        return obj as NewType
    }

    public static objectIs<T>(obj: T, knownType: KnownTypes): boolean {
        return obj !== null && obj !== undefined && typeof obj === knownType
    }
}
